import VSelectVoucherIssueType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectVoucherIssueType', VSelectVoucherIssueType),
};
